<div class="grid p-mobile-friendly animate-fade-in">
  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <h1 class="text-center text-2xl md:text-3xl font-bold animate-slide-up">Select Your Company</h1>
  </div>

  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <div class="grid gap-3">
      @for (administratorCompany of administratorCompanyList; track administratorCompany; let i = $index) {
        <div class="col-12 animate-slide-up" [style.animation-delay]="i * 0.1 + 's'">
          <a [routerLink]="getRouterLink(administratorCompany.company_id)" class="block no-underline">
            <div class="card-modern shadow-hover p-4 cursor-pointer">
              <div class="flex align-items-center">
                <!-- Icon on the left -->
                <div
                  class="w-3rem h-3rem border-circle flex align-items-center justify-content-center shadow-soft flex-shrink-0"
                  style="background-color: var(--primary-color)"
                >
                  <i class="pi pi-building text-white text-xl"></i>
                </div>

                <!-- Text content vertically aligned to icon -->
                <div class="flex-grow-1 ml-3 flex align-content-center">
                  <h3 class="m-0 text-lg md:text-xl font-semibold">
                    {{ administratorCompany.company_name }}
                  </h3>
                </div>

                <!-- Chevron on the right -->
                <i class="pi pi-angle-right text-2xl text-color-secondary ml-3"></i>
              </div>
            </div>
          </a>
        </div>
      }
    </div>
  </div>

  @if (!isLoading && administratorCompanyList.length === 0) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 text-center">
      <div class="card-modern p-5">
        <i class="pi pi-info-circle text-4xl text-color-secondary mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">No Companies Found</h3>
        <p class="text-color-secondary">You don't have access to any companies yet.</p>
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 text-center">
      <div class="card-modern p-5">
        <i class="pi pi-spin pi-spinner text-4xl text-color-secondary mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">Loading Companies...</h3>
      </div>
    </div>
  }
</div>
